<template>
  <vxe-pager
    :align="align"
    :current-page="currentPage"
    :page-size="pageSize"
    :total="pageTotal"
    :page-sizes="pageSizes"
    :layouts="layouts"
    :background="background"
    :border="border"
    :perfect="perfect"
    @page-change="handelPageChange"
  >
  </vxe-pager>
</template>
<script>
export default {
  props: {
    currentPage: {
      default: 0,
    },
    pageSize: {
      default: 10,
    },
    pageTotal: {
      default: 0,
    },
    pageSizes: {
      type: Array,
      default: () => [5, 10, 15, 20, 50, 100],
    },
    size: {
      type: String,
      default: 'small',
    },
    align: {
      type: String,
      default: 'right',
    },
    layouts: {
      type: Array,
      default: () => [
        'Total',
        'Sizes',
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'FullJump',
      ],
    },
    background: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    perfect: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handelPageChange({ currentPage, pageSize }) {
      this.$emit('change', {
        current: currentPage,
        size: pageSize,
      })
    },
  },
}
</script>
